<template>
  <div>
    <v-toolbar dense class="secondary">
      <v-toolbar-title style="color:white!important"
        >Select Payment Method</v-toolbar-title
      >
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs5 style="height:600px;">
        <v-card style="margin-top:20px;width:95%;;height:580px">
          <v-list
            subheader
            style="padding-bottom:0px;margin-top:10px;"
            three-line
          >
            <v-divider></v-divider>
            <!--   <v-list-tile  @click="way='debit'" :class="[way=='debit'?'primary':'']">
            <v-list-tile-avatar >
              <img :src="require('../assets/card.svg')" style="border-radius:0px;padding:5px">
            </v-list-tile-avatar>
            <v-list-tile-content :class="[way=='debit'?'whitecolor':'']">
              <v-list-tile-title >Debit Card</v-list-tile-title>
              <v-list-tile-sub-title >{{cdebit}}</v-list-tile-sub-title>
            </v-list-tile-content>
             </v-list-tile>
        <v-divider></v-divider>
          <v-list-tile @click="way='credit'" :class="[way=='credit'?'primary':'']">
            <v-list-tile-avatar>
              <img :src="require('../assets/card.svg')" style="border-radius:0px;padding:5px">
            </v-list-tile-avatar>
            <v-list-tile-content :class="[way=='credit'?'whitecolor':'']">
              <v-list-tile-title >Credit Card</v-list-tile-title>
              <v-list-tile-sub-title >{{ccredit}}</v-list-tile-sub-title>
            </v-list-tile-content>
             </v-list-tile>

        <v-divider></v-divider>
          <v-list-tile @click="way='net'"  :class="[way=='net'?'primary':'']">
            <v-list-tile-avatar >
              <img :src="require('../assets/browser.svg')" >
            </v-list-tile-avatar>
            <v-list-tile-content :class="[way=='net'?'whitecolor':'']">
              <v-list-tile-title >Net Banking</v-list-tile-title>
              <v-list-tile-sub-title >{{cnetbank}}</v-list-tile-sub-title>
            </v-list-tile-content>
             </v-list-tile>
        <v-divider></v-divider>
            -->
            <v-list-tile
              v-if="bhimupiactive"
              @click="way = 'paytm'"
              :class="[way === 'paytm' ? 'primary' : '']"
            >
              <v-list-tile-avatar>
                <img :src="require('../assets/bhim.png')" />
              </v-list-tile-avatar>
              <v-list-tile-content
                :class="[way === 'paytm' ? 'whitecolor' : '']"
              >
                <v-list-tile-title>BHIM UPI</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  cpaytmwallet
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="razorActive"
              @click="way = 'razorpay'"
              :class="[way === 'razorpay' ? 'primary' : '']"
            >
              <v-list-tile-avatar>
                <img :src="require('../assets/razorpay.svg')" />
              </v-list-tile-avatar>
              <v-list-tile-content
                :class="[way === 'razorpay' ? 'whitecolor' : '']"
              >
                <v-list-tile-title>Load Balance</v-list-tile-title>
                <v-list-tile-sub-title>
                  0% for BHEEM,GOOGLE PAY, PHONE PAY, PAYTM, AIRTEL MONEY AND
                  ALL UPI APP
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  1% for Net Banking, ATM (Debit card), Credit Card
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="paytmpgActive"
              @click="way = 'paytmpg'"
              :class="[way === 'paytmpg' ? 'primary' : '']"
            >
              <v-list-tile-avatar>
                <img :src="require('../assets/paytm.svg')" />
              </v-list-tile-avatar>
              <v-list-tile-content
                :class="[way === 'paytmpg' ? 'whitecolor' : '']"
              >
                <v-list-tile-title>Load Balance</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile
              v-if="directbhimupiactive"
              @click="way = 'bhim'"
              :class="[way === 'bhim' ? 'primary' : '']"
            >
              <v-list-tile-avatar>
                <img :src="require('../assets/bhim.png')" />
              </v-list-tile-avatar>
              <v-list-tile-content
                :class="[way === 'bhim' ? 'whitecolor' : '']"
              >
                <v-list-tile-title>DIRECT BHIM UPI</v-list-tile-title>
                <v-list-tile-sub-title>
                  <div v-if="cpaytmupi != ''">{{ cpaytmupi }}<br /></div>
                  <div style="color:red">
                    If your BHIM UPI already added in our system then your
                    wallet will loaded automatically in short time
                  </div>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>

           <v-list-tile
              v-if="iciciActive"
              @click="way = 'icici'"
              :class="[way === 'icici' ? 'primary' : '']"
            >
              <v-list-tile-avatar>
                <img :src="require('../assets/icici_upi.png')" />
              </v-list-tile-avatar>
              <v-list-tile-content
                :class="[way === 'icici' ? 'whitecolor' : '']"
              >
                <v-list-tile-title>DIRECT BHIM UPI</v-list-tile-title>
                <v-list-tile-sub-title>
                  <div > Load Wallet charge : 0.0 %<br /></div>
                  <div style="color:red">
                    Pay using ICICI UPI and qr code, your balance will get loaded actual in short time.
                  </div>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <!--
      <v-list-tile @click="way='yesbank'" :class="[way==='yesbank'?'primary':'']">
            <v-list-tile-avatar >
              <img :src="require('../assets/yesbank.png')" >
            </v-list-tile-avatar>
            <v-list-tile-content :class="[way==='yesbank'?'whitecolor':'']">
              <v-list-tile-title >Yesbank UPI</v-list-tile-title>
              <v-list-tile-sub-title >{{cyesbankupi}}</v-list-tile-sub-title>
            </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
-->
            <v-list-tile
              v-if="UPIVPN"
              @click="way = 'vpn'"
              :class="[way === 'vpn' ? 'primary' : '']"
            >
              <v-list-tile-avatar>
                <img :src="require('../assets/bhim.png')" alt="" />
              </v-list-tile-avatar>
              <v-list-tile-content :class="[way === 'vpn' ? 'whitecolor' : '']">
                <v-list-tile-title>BHIM UPI DYNAMIC QR CODE</v-list-tile-title>
                <v-list-tile-sub-title>
                  <div style="color:red">
                    Pay using Dynamic QR Code. Your balance will get loaded
                    actual in short time.
                  </div>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs7 style="min-height:600px; max-height:1000px;height:auto">
        <v-card
          style="margin-top:20px;width:100%;min-height:580px;padding:10px;float:left"
        >
          <Debit v-show="way === 'debit'" />
          <Credit v-show="way === 'credit'" />
          <Netbank v-show="way === 'net'" />
          <Paytm
            v-show="way === 'paytm'"
            :charge="cpaytmwallet"
            :url="ipaytmwallet"
          />
          <Upi v-show="way === 'bhim'" :charge="cpaytmupi" :url="ipaytmupi" />
          <YesbankUpi
            v-show="way === 'yesbank'"
            :charge="cyesbankupi"
            :url="iyesbankupi"
          />
          <VPN v-show="way === 'vpn'"></VPN>
          <RazorPay v-show="way === 'razorpay'" />
          <PaytmPG v-show="way === 'paytmpg'" />
          <ICICI v-show="way === 'icici'" />
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Credit from "../payment/Credit.vue";
import Debit from "../payment/Debit.vue";
import Netbank from "../payment/Netbank.vue";
import Paytm from "../payment/Paytm.vue";
import Upi from "../payment/Upi.vue";
import YesbankUpi from "../payment/YesbankUpi.vue";
import PaytmPG from "../payment/PaytmPG.vue";
import VPN from "../payment/VPN";
import RazorPay from "../payment/RazorPay";
import ICICI from "../payment/ICICI";
export default {
  data() {
    return {
      way: "",
      cdebit: "",
      ccredit: "",
      cnetbank: "",
      cpaytmupi: "",
      cpaytmwallet: "",
      cyesbankupi: "",
      crazorpay: "",
      ipaytmupi: "",
      paytmpgActive: false,
      ipaytmwallet: "",
      iyesbankupi: "",
      bhimupiactive: false,
      directbhimupiactive: false,
      UPIVPN: false,
      iciciActive: false,
      razorActive: false,
    };
  },
  methods: {
    fetchDetails() {
      let url = "GetPayment_Gateway_List";
      let vm = this;
      let doc = {};
      vm.dialog = true;
      vm.$store
        .dispatch("axiospost", {
          url: url,
          data: doc,
        })
        .then(function(res) {
          vm.dialog = false;
          let data = res.data;

          for (let i = 0; i < data.length; i++) {
            if (
              data[i].PaymentMode === "BhimUPI" &&
              data[i].Payment_Type === "UPI"
            ) {
              vm.cpaytmwallet = data[i].Comm + "% of Service Charge";
              vm.ipaytmwallet = vm.$store.getters.src + "Admin/" + data[i].Url;
              if (data[i].IsActive === 0) {
                vm.bhimupiactive = false;
              } else {
                vm.bhimupiactive = true;
              }
            }
            if (
              data[i].PaymentMode === "DirectUPI" &&
              data[i].Payment_Type === "Wallet"
            ) {
              vm.cpaytmupi = data[i].Comm + "% of Service Charge";
              vm.ipaytmupi = vm.$store.getters.src + "Admin/" + data[i].Url;
              if (data[i].IsActive === 0) {
                vm.directbhimupiactive = false;
              } else {
                vm.directbhimupiactive = true;
              }
            }
            if (
              data[i].PaymentMode === "UpiWithVPA" &&
              data[i].Payment_Type === "Wallet"
            ) {
              vm.cyesbankupi = data[i].Comm + "% Service Charge";
              vm.iyesbankupi = vm.$store.getters.src + "Admin/" + data[i].Url;
              if (data[i].IsActive === 0) {
                vm.UPIVPN = false;
              } else {
                vm.UPIVPN = true;
              }
            }
            if (
              data[i].PaymentMode === "RazorPay" &&
              data[i].Payment_Type === "Wallet"
            ) {
              vm.crazorpay = data[i].Comm + "% Service Charge";
              if (data[i].IsActive === 0) {
                vm.razorActive = false;
              } else {
                vm.razorActive = true;
              }
            }
            if (data[i].PaymentMode === "PayTmPg") {
              vm.paytmpgActive = data[i].IsActive === 1;
            }
            if (data[i].PaymentMode === "ICICI_PG") {
              vm.iciciActive = data[i].IsActive === 1;
            }
          }
        })
        .catch(function(error) {});
    },
  },
  mounted() {
    let vm = this;
    vm.fetchDetails();
  },
  components: {
    Upi,
    Paytm,
    RazorPay,
    PaytmPG,
    Debit,
    Netbank,
    Credit,
    YesbankUpi,
    ICICI,
    VPN,
  },
};
</script>

<style>
.whitecolor {
  color: white !important;
}
</style>
